export const cleanInvalidObj = <
  T extends Record<string, any> = Record<string, any>,
>(
  obj: T,
) =>
  Object.keys(obj).reduce<Record<string, any>>(
    (acc, key) => (obj[key] ? { ...acc, [key]: obj[key] } : acc),
    {},
  );
